import { defineComponent as _defineComponent } from 'vue'
import { Notification, NotificationType } from '~/store/notificationStore'
import CheckCircleIcon from '~/assets/img/CheckCircleIcon.svg'
import ExclamationCircleIcon from '~/assets/img/ExclamationCircleIcon.svg'
import InformationCircleIcon from '~/assets/img/InformationCircleIcon.svg'
import { useContext } from '@nuxtjs/composition-api'


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationFooterNotifications',
  setup(__props) {

const {
  $app: { notif },
} = useContext()

function getNotificationIcon(notification: Notification) {
  return {
    [NotificationType.Success]: CheckCircleIcon,
    [NotificationType.Error]: ExclamationCircleIcon,
    [NotificationType.Info]: InformationCircleIcon,
  }[notification.type]
}

function getNotificationColorClass(notification: Notification) {
  return {
    [NotificationType.Success]: 'text-success-500',
    [NotificationType.Error]: 'text-emotion-500',
    [NotificationType.Info]: 'text-primary-500',
  }[notification.type]
}

return { __sfc: true,notif, getNotificationIcon, getNotificationColorClass }
}

})